import { render, staticRenderFns } from "./AddRolePermission.vue?vue&type=template&id=7e37c993&scoped=true"
import script from "./AddRolePermission.vue?vue&type=script&lang=js"
export * from "./AddRolePermission.vue?vue&type=script&lang=js"
import style1 from "./AddRolePermission.vue?vue&type=style&index=1&id=7e37c993&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e37c993",
  null
  
)

export default component.exports